import React, { useEffect, useState } from 'react';
import { Avatar, Divider, List, Popconfirm, Skeleton } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Trash2 } from 'lucide-react';
import { detelePermissionRole } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import axios from 'axios';



interface DataType {
    name: string;
    permission_id: number;

}

interface ListingsDrawerProps {
    roleId: string
    roles: string[]

}

const RolePermissionListing: React.FC<ListingsDrawerProps> = ({ roleId, roles }) => {
    const [data, setData] = useState<DataType[]>([]);
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()




    const loadMoreData = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/rolePermissions/${roleId}`, {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };




    useEffect(() => {
        loadMoreData();
    }, [roleId]);



    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const deletePermissionRole = (permissionId: any, roleId: any, callback: any) => {
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.delete(`/api/v1/rolePermissions/deletePermissionRole/${permissionId}/${roleId}`, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    successNotification("role deleted",
                        `role with id ${roleId} was deleted`,
                        'topRight'
                    );

                }
                callback()
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    return (
        <div
            id="scrollableDiv"
            style={{
                height: 400,
                overflow: 'auto',
                padding: '0 16px',
                border: '1px solid rgba(140, 140, 140, 0.35)',
            }}
        >
            <InfiniteScroll
                dataLength={data.length}
                next={loadMoreData}
                hasMore={data.length < 1}
                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                endMessage={<Divider plain>{`🤐 Total  ${data.length} permission(s)`}</Divider>}
                scrollableTarget="scrollableDiv"
            >
                <List
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item key={item.permission_id}>
                            <List.Item.Meta
                                avatar={""}
                                title={item.name}
                            />
                            <Popconfirm
                                title={`are you sure you are deleting ${item.name}`}
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => deletePermissionRole(item.permission_id, roleId, loadMoreData)}
                            >
                                {roles.includes('permission-delete') && (<div className="flex items-center">
                                    <Trash2 className="w-5 h-5 text-red-600 cursor-pointer" />
                                </div>)}
                            </Popconfirm>
                        </List.Item>
                    )}
                />
            </InfiniteScroll>
        </div>
    );
};

export default RolePermissionListing;